export default {
    install(Vue, options) {
        //  时间  2010-01-12
        Vue.filter('getTime', function (val) {
            let day = new Date(val * 1000);
            let y = day.getFullYear();
            let m = day.getMonth() + 1;
            let d = day.getDate();
            return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d);
        });
        //  时间  2010-01-12 10:00
        Vue.filter('getNewTime', function (val) {
            let day = new Date(val * 1000);
            let y = day.getFullYear();
            let m = day.getMonth() + 1;
            let d = day.getDate();
            let h = day.getHours();
            let s = day.getMinutes();
            return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d) + '  ' + (h < 10 ? '0' + h : h) + ':' + (s < 10 ? '0' + s : s);
        });
        // 时间  12:00
        Vue.filter('getDateTime', function (val) {
            let day = new Date(val * 1000);
            let h = day.getHours();
            let m = day.getMinutes();
            return (h < 10 ? '0' + h : h) + ':' + (m < 10 ? '0' + m : m);
        });
        Vue.filter('getTimeDifference', function (val) {
            var date1 = (Date.parse(new Date()))/1000;//计算当前时间戳 
            var date3 =  val- date1; //时间差的毫秒数
            if(date3 / (24 * 3600 ) >0 && date3 / (24 * 3600 ) < 1)return Math.floor(date3 / (24 * 3600 )*24)+"小時"
            return Math.ceil(Math.abs(date3 / (24 * 3600 )))+"天";
        });

        // 千分货币格式 11,000
        Vue.filter('numFormat', function (val) {
            if (!val) return '0';
            return val.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
        });
        Vue.filter('priceUnit', function (val) {
            let k = 10000;
            let sizes = ['', '萬', '億'];
            let unit = '';
            let i = Math.floor(Math.log(val) / Math.log(k));
            val = ((val / Math.pow(k, i)));
            // .toFixed(2)
            unit = sizes[i];
            return '$'+ val + unit 
        });
    }
};
